import React from "react";
import {useLazyQuery, useMutation, useSubscription} from "@apollo/client";
import {Box, Grommet, Tab, Tabs, Text} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {tenant, tenantType} from "../tenant.js";
import {Divider, IconButton, Tooltip} from "@mui/material";
import {
    DELETE_PRODUCT,
    GET_PRODUCTS,
    GET_PRODUCTS_BY_CODE, GET_PRODUCTS_BY_DESCRIPTION,
    GET_PRODUCTS_BY_NAME,
    UPSERT_PRODUCT
} from "./ProductGQL.jsx";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add.js";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import InputAdornment from "@mui/material/InputAdornment";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {AddProductWrapper} from "./AddProduct";
import AddMovement from "./AddMovements.js";
import MovementList from "./MovementsList.jsx";
import LoadingLayer from "../loadingLayer/LoadingLayer.jsx";
import TextField from "@mui/material/TextField";
import WareHouseMachine from "./WareHouseMachine.js";
import {colors, grommetTheme, toggleButtonGroupStyles} from "../../utilis/theme.js";
import ConfirmDialog from "../common/ConfirmDialog.jsx";
function WareHouse(props){

    const [products,setProducts]=React.useState([]);
    const [showAddProduct,setShowAddProduct]=React.useState(false);
    const [showAddMovement,setShowAddMovement] = React.useState(false);
    const [showAddMovementList,setShowMovementList] = React.useState(false)
    const [pageNumber,setPageNumber] = React.useState(1);
    const [deleteProduct]=useMutation(DELETE_PRODUCT)
    const [prodSel,setProdSel]=React.useState(null);
    const [textSearch,setTextSearch] = React.useState("");
    const [searchType, setSearchType] = React.useState('Codice');
    const [movementType,setMovementType] = React.useState("");
    const [confirmDialog, setConfirmDialog] = React.useState({open: false, productId: null});


    const [ queryGetProducts,{loading: loadingProducts}
    ] = useLazyQuery(GET_PRODUCTS, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        const products=data[tenant]["products"]
        if(products){
            setProducts(products);
        }
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

    const [ queryGetProductsByName,{loading: loadingProductsByName}
    ] = useLazyQuery(GET_PRODUCTS_BY_NAME, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        const products=data[tenant]["productsByName"]
        if(products){
            setProducts(products);
        }
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

    const [ queryGetProductsByCode,{loading: loadingProductsByCode}
    ] = useLazyQuery(GET_PRODUCTS_BY_CODE, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        console.log("DATA PRODUCT CODE",data);
        const products=data[tenant]["productsByCode"]
        if(products){
            setProducts(products);
        }
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

     const [ queryGetProductsByDescription,{loading: loadingProductsByDescription}
    ] = useLazyQuery(GET_PRODUCTS_BY_DESCRIPTION, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        const products=data[tenant]["productsByDescription"]
        if(products){
            setProducts(products);
        }
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

    const columnsWareHouse = [
    { field: 'name', headerName: 'Nome Prodotto', width: 300 },
    { field: 'code', headerName: 'Codice', width: 200 },
        { field: 'description', headerName: 'Descrizione', width: 200,
         renderCell: (cellValues) => {
           const val = cellValues.row.description || '';
           return(
             <Tooltip title={val} arrow placement="top">
               <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', display:'block'}}>{val}</span>
             </Tooltip>
           )
         }
        },
      //   { field: 'interval', headerName: 'Intervallo', width: 100 },
      { field: 'quantity', headerName: 'Quantità', width: 120,
       renderCell: (cellValues) => {
           const val = cellValues.row.quantity.toFixed(2);
           return(
             <Tooltip title={val} arrow placement="top">
               <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', display:'block'}}>{val}</span>
             </Tooltip>
           )
       }
      },
      { field: 'um', headerName: 'U.M.', width: 100 },
      { field: 'ppu', headerName: 'Prezzo/U.M.', width: 130,
       renderCell: (cellValues) => {
           return(
              <Text>{cellValues.row.ppu != null ? `€ ${cellValues.row.ppu.toFixed(2)}` : '-'}</Text>
           )
       }
      },
      { field: 'totale', headerName: 'Totale', width: 130,
       renderCell: (cellValues) => {
           const qty = cellValues.row.quantity || 0;
           const price = cellValues.row.ppu || 0;
           const totale = qty * price;
           return(
              <Text weight="bold">{totale > 0 ? `€ ${totale.toFixed(2)}` : '-'}</Text>
           )
       }
      },
        { field: 'currentlyInStock', headerName: 'Censito', width: 100, headerAlign: 'center', align: 'center',
           renderCell: (cellValues) => {
            return(
                <Box style={{width:16, height:16, borderRadius:'50%', backgroundColor: cellValues.row.currentlyInStock ? colors.success : colors.error}} />
            )
           }
           },

        { field: 'Movimenti', headerName: 'Movimenti', width: 200,
                renderCell: (cellValues) => {
                    return(
                        <Box direction={"row"} gap={"xsmall"} align="center">
                              <Tooltip title="Carica" arrow>
                                <IconButton
                                      color="success"
                                      onClick={(event) => {
                                          setProdSel(cellValues.row);
                                          setShowAddMovement(true);
                                          setMovementType("carico");
                                      }}
                                    >
                                      <AddCircleIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Scarica" arrow>
                                <IconButton
                                      color="error"
                                      onClick={(event) => {
                                          setMovementType("scarico");
                                          setProdSel(cellValues.row);
                                          setShowAddMovement(true);
                                      }}
                                    >
                                      <RemoveCircleIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Visualizza" arrow>
                                <IconButton
                                      color="primary"
                                      onClick={(event) => {
                                          setProdSel(cellValues.row);
                                          setShowMovementList(true);
                                      }}
                                    >
                                      <VisibilityIcon />
                                </IconButton>
                              </Tooltip>
                        </Box>
                    )
                }
            },
   {
    field: 'Azioni',
    headerName: 'Azioni',
    width: 120,
    renderCell: (cellValues) => {
      return (
        <Box direction={"row"} gap={"xsmall"} align="center">
          <Tooltip title="Modifica" arrow>
            <IconButton
              color="primary"
              onClick={(event) => {
                setProdSel(cellValues.row);
                setShowAddProduct(true);
              }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancella" arrow>
            <IconButton
              color="error"
              onClick={() => setConfirmDialog({open: true, productId: cellValues.row.id})}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      );},
   },
  ];


    function getProducts(){
        queryGetProducts({variables:{area: JSON.parse(sessionStorage.getItem("Cantiere")) || props.aree[0] || JSON.parse(sessionStorage.getItem("areeId"))[0],page:pageNumber,pageSize:1000}})
            .catch((err)=>console.log("ERROR",err))
    }
    function getProductsByName(text){
        queryGetProductsByName({variables:{area: JSON.parse(sessionStorage.getItem("Cantiere")) || props.aree[0] || JSON.parse(sessionStorage.getItem("areeId"))[0],name:text}})
            .catch((err)=>console.log("ERROR",err))
    }

    function getProductsByCode(text){
        queryGetProductsByCode({variables:{area: JSON.parse(sessionStorage.getItem("Cantiere")) || props.aree[0] || JSON.parse(sessionStorage.getItem("areeId"))[0],code:text}})
            .catch((err)=>console.log("ERROR",err))
    }

     function getProductsByDescription(text){
        queryGetProductsByDescription({variables:{area: JSON.parse(sessionStorage.getItem("Cantiere")) || props.aree[0] || JSON.parse(sessionStorage.getItem("areeId"))[0],desc:text}})
            .catch((err)=>console.log("ERROR",err))
    }


    function getProductsToProps(){
        if(textSearch!=="" && searchType==="Codice"){
            getProductsByCode(textSearch);
        }else if(textSearch!=="" && searchType==="Nome"){
            getProductsByName(textSearch);
        }else if(textSearch!=="" && searchType==="Descrizione"){
            getProductsByDescription(textSearch);
        }else{
            getProducts();
        }
    }

  React.useEffect(()=>{
     getProducts();
  },[props.aree])

    React.useEffect(()=>{
        if(textSearch===""){
            getProducts();
        }
    },[textSearch])

    return (
        <Grommet theme={grommetTheme} themeMode="dark" style={{minHeight:'100vh'}} >
            <Tabs>
                <Tab title="Magazzino e movimenti">
                    <Box overflow="hidden" aligns="center" pad="small" margin="10px">
                      <Text color={colors.primary} size="large" weight="bold" alignSelf="start">MAGAZZINO</Text>
                      <Divider/>
                    </Box>
                    <Box pad={"small"} overflow="auto" height="83vh" width="100%" alignSelf='center' style={{marginTop:'10px', overflowX:'hidden', display:'flex', flexDirection:'column'}}>
                           <Box direction="row" align="center" gap="small" margin={{bottom:'small'}} wrap>
                                <ToggleButtonGroup
                                  value={searchType}
                                  exclusive
                                  onChange={(e, val) => { if(val) setSearchType(val); }}
                                  size="small"
                                  sx={toggleButtonGroupStyles}
                                >
                                  <ToggleButton value="Codice">Codice</ToggleButton>
                                  <ToggleButton value="Nome">Nome</ToggleButton>
                                  <ToggleButton value="Descrizione">Descrizione</ToggleButton>
                                </ToggleButtonGroup>
                                <TextField
                                  size="small"
                                  style={{flex:1, minWidth:'200px'}}
                                  placeholder={`Cerca per ${searchType.toLowerCase()}...`}
                                  value={textSearch}
                                  onChange={(event) => setTextSearch(event.target.value)}
                                  onKeyDown={(event) => {
                                    if(event.key === 'Enter'){
                                      if(searchType==="Codice") getProductsByCode(textSearch);
                                      else if(searchType==="Nome") getProductsByName(textSearch);
                                      else getProductsByDescription(textSearch);
                                    }
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon style={{color:colors.primary}} />
                                      </InputAdornment>
                                    ),
                                    endAdornment: textSearch && (
                                      <InputAdornment position="end">
                                        <IconButton size="small" onClick={() => { setTextSearch(""); getProducts(); }}>
                                          <ClearIcon fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <Tooltip title="Cerca" arrow>
                                  <IconButton
                                    style={{backgroundColor:colors.primary, color:colors.white}}
                                    onClick={() => {
                                      if(searchType==="Codice") getProductsByCode(textSearch);
                                      else if(searchType==="Nome") getProductsByName(textSearch);
                                      else getProductsByDescription(textSearch);
                                    }}
                                  >
                                    <SearchIcon />
                                  </IconButton>
                                </Tooltip>
                           </Box>
                        <div style={{ flex: 1, minHeight: 0, width: '100%' }}>
                          <DataGrid
                            rows={products || []}
                            columns={columnsWareHouse}
                            pageSize={100}
                            onPageChange={(page, details)=>{
                                setPageNumber(page);
                            }}
                          />
                        </div>
                          <Fab
                            onClick={()=> {setShowAddProduct(true)}}
                            style={{  margin: 0,
                                top: 'auto',
                                right: 60,
                                bottom: 10,
                                left: 'auto',
                                position: 'fixed',}} color="primary" aria-label="add">
                            <AddIcon />
                          </Fab>
                    </Box>
                    {
                        showAddProduct && <AddProductWrapper role={props?.role} getProducts={getProductsToProps} product={prodSel} onEscLayer={()=>{setShowAddProduct(false);setProdSel(null);}}/>
                    }
                    {
                        showAddMovement && <AddMovement movementType={movementType} getProducts={getProductsToProps} prodSel={prodSel} onEscLayer={()=>setShowAddMovement(false)}/>
                    }
                    {
                        showAddMovementList && <MovementList getProducts={getProductsToProps} prodSel={prodSel} onEscLayer={()=>setShowMovementList(false)}/>
                    }
                    {
                        (loadingProducts || loadingProductsByCode || loadingProductsByName || loadingProductsByDescription) && <LoadingLayer/>
                    }
                    </Tab>
                {
                   props?.machineProductsPermission &&
                    <Tab title="Macchine-Prodotti">
                        <WareHouseMachine/>
                    </Tab>
                }

            </Tabs>
            <ConfirmDialog
                open={confirmDialog.open}
                onClose={() => setConfirmDialog({open: false, productId: null})}
                onConfirm={() => {
                    deleteProduct({variables:{id:confirmDialog.productId}});
                    getProducts();
                }}
                message="Sei sicuro di voler eliminare il prodotto selezionato?"
                type="delete"
                confirmLabel="Elimina"
            />
        </Grommet>
    )
}

export default WareHouse;

